module.exports = __webpack_public_path__ + "img/265.f2b04c48.jpg";